import { logoutEndPoints } from "./config"
import httpServices from "./httpServices"

export const dataLogout = async (logoutdata) => {
    return await httpServices.post(logoutEndPoints.logout, logoutdata)
}
export const listLogout = async () => {
    return await httpServices.get(logoutEndPoints.listLogout)
}